import { Message } from '@gonfalon/messages/Message';
import { msg } from '@gonfalon/messages/msg';
import { IconButton } from '@launchpad-ui/components';

import styles from './CodeEditorRetryFallback.module.css';

export const CodeEditorRetryFallback = ({ resetErrorBoundary }: { resetErrorBoundary: () => void }) => (
  <div className={styles.fallback}>
    <div className={styles.retry}>
      <Message id="ui.codeEditor.loadError" />{' '}
      <IconButton
        onPress={resetErrorBoundary}
        aria-label={msg('ui.codeEditor.retryLabel')}
        name="Retry loading code editor"
        size="small"
        variant="minimal"
        icon="sync"
      />
    </div>
  </div>
);
